import { Link } from "@remix-run/react";
import theme from "~/theme/default";
import { classNames } from "~/utils";

export function EventsHome() {
  const { button } = theme;
  const { base } = button;

  return (
    <div className="section-wrapper py-16 md:py-24">
      <section>
        <h2 className="text-2xl font-bold text-textColor-primary lg:text-[40px]">
          Veranstaltungen
        </h2>
        <p className="mt-2 max-w-4xl text-base leading-relaxed text-textColor-primary">
          Ob kulturelle Events oder Fortbildungen - hier findest Du aktuelle
          Angebote, die Dein Wissen vertiefen, Deine Horizonte erweitern und
          Dich in Deinem Unterricht unterstützen.
        </p>

        {/* Embedded Events Calendar */}
        <div className="mt-8">
          <iframe
            data-tec-events-ece-iframe="true"
            src="https://explore.ru-digital.de/veranstaltungen/calendar-embed/xhfwiLsae92/embed/"
            title="Veranstaltungen Calendar"
          />
        </div>

        {/* CTA button */}
        <div className="mt-10 flex w-full justify-center">
          <Link
            to="/veranstaltungen"
            className={classNames(
              base,
              "ml-3 inline-flex items-center rounded-full border border-transparent bg-btnColor-secondary px-6 py-2 text-xs font-medium text-white shadow-sm hover:bg-btnColor-hoveSecondary focus:outline-none focus:ring-2 focus:ring-btnColor-secondary focus:ring-offset-2 md:px-8 md:text-sm"
            )}
          >
            entdecke weitere Veranstaltungen
          </Link>
        </div>
      </section>
    </div>
  );
}
